import { ReactElement, ChangeEvent, Children } from 'react'
import './RadioButtonGroup.scss'
import classNames from 'classnames'
import { RadioButton } from '../RadioButton'

type OnChangeType = (
  newSelection: string | number,
  name: string,
  event: ChangeEvent<HTMLInputElement>,
) => void

export const RadioButtonGroup = ({
  children,
  className = 'RadioButtonGroup__base',
  name,
  onChange,
  defaultSelected,
  valueSelected,
  layout = 'vertical',
  size,
  disabled,
}: {
  children: ReactElement[]
  name: string
  className?: string
  defaultSelected?: string | number
  valueSelected: string | number | null
  onChange: OnChangeType
  layout?: 'horizontal' | 'vertical'
  size?: 's' | 'm' | 'l' | 'xl'
  disabled?: boolean
}) => {
  const wrapperClasses = classNames(' ', {
    'RadioButtonGroup--horizontal': layout === 'horizontal',
    'RadioButtonGroup--vertical': layout === 'vertical',
  })

  const selected = valueSelected || defaultSelected

  const handleChange: OnChangeType = (newSelection, _name, event) => {
    if (onChange) {
      onChange(newSelection, _name, event)
    }
  }

  const getRadioButtons = () => {
    const radioButtons = Children.map(children, (radioButton) => {
      const { value, label, labelSub } = radioButton.props

      if (Object.prototype.hasOwnProperty.call(radioButton, 'checked')) {
        console.error(
          `When using RadioButton components as children of a RadioButtonGroup
          component, do not use the 'checked' prop of any RadioButton components.
          It will be managed by the RadioButtonGroup`,
        )
      }

      return (
        <RadioButton
          label={label}
          labelSub={labelSub}
          name={name}
          value={value}
          size={size}
          onChange={handleChange}
          checked={value === selected}
          disabled={disabled}
        />
      )
    })

    return radioButtons
  }

  return (
    <div className={`RadioButtonGroup${wrapperClasses} ${className}`}>
      {getRadioButtons()}
    </div>
  )
}
